export function FeedSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div aria-busy="true" aria-label="Loading posts">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex gap-3 border-b border-border px-4 py-4">
          <div className="h-10 w-10 shrink-0 animate-pulse rounded-full bg-muted" />
          <div className="flex-1 space-y-2">
            <div className="h-3 w-36 animate-pulse rounded bg-muted" />
            <div className="h-3 w-full animate-pulse rounded bg-muted" />
            <div className="h-3 w-4/5 animate-pulse rounded bg-muted" />
            {i % 3 === 0 && <div className="h-40 w-full animate-pulse rounded-2xl bg-muted" />}
            <div className="flex gap-6 pt-1">
              {[0, 1, 2, 3].map((j) => <div key={j} className="h-3 w-8 animate-pulse rounded bg-muted" />)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
